module.exports = __webpack_public_path__ + "static/img/绞车硐室检修规范操作识别.e964a45a.png";